import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import zhHant from "vuetify/lib/locale/zh-Hant";

Vue.use(Vuetify);

Vuetify.config.silent = process.env.NODE_ENV === "production";

export default new Vuetify({
  theme: {
    options: { cspNonce: "dQw4w9WgXcQAGdsJdsfHdasF" },
  },
  lang: {
    locales: { zhHant },
    current: "zhHant",
  },
});
